import { Helmet } from "react-helmet";

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
export const Meta = (props) => <Helmet {...props} />;
